import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'app-form-input-checkbox',
    templateUrl: './form-input-checkbox.component.html',
    encapsulation: ViewEncapsulation.Emulated
})
export class FormInputCheckboxComponent {
    @Input() F: FormControl;
    @Input() ControlName: string;
    @Input() LabelString: string;
    @Input() id: string;
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/form/form-input-checkbox.component.ts